export default __webpack_public_path__ + "static/media/01.cdd84509.jpg";